/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ITargetAudience {
    get(filter: string | null | undefined, includeInactive: boolean | null | undefined, orderColumn: string | null | undefined, orderDesc: boolean | null | undefined, pageNumber: number | null | undefined, pageLength: number | null | undefined, archived: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<PageOfAudienceListElement>;
    create(model: AudienceCreateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse>;
    get2(id: number, cancelToken?: CancelToken): AxiosPromise<AudienceResponse>;
    update(id: number, model: AudienceUpdateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse>;
    remove(id: number, cancelToken?: CancelToken): AxiosPromise<void>;
    clone(id: number, model: AudienceCreateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse>;
    createGroup(id: number, model: AudienceFilterGroupModel, cancelToken?: CancelToken): AxiosPromise<AudienceFilterGroupModel>;
    archive(id: number, cancelToken?: CancelToken): AxiosPromise<void>;
    unarchive(id: number, cancelToken?: CancelToken): AxiosPromise<void>;
    validate(id: number, cancelToken?: CancelToken): AxiosPromise<AudienceValidationResult>;
    getAudienceDeliverability(id: number, cancelToken?: CancelToken): AxiosPromise<DeliverabilityBreakdownItem[]>;
}

export const BASE_URL_TOKEN_TargetAudience = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class TargetAudience implements ITargetAudience {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_TargetAudience) @optional() private readonly baseUrl = "") {
    }

    get(filter: string | null | undefined, includeInactive: boolean | null | undefined, orderColumn: string | null | undefined, orderDesc: boolean | null | undefined, pageNumber: number | null | undefined, pageLength: number | null | undefined, archived: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<PageOfAudienceListElement> {
        let url_ = "/app/api/marketing/audience?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (orderColumn !== undefined && orderColumn !== null)
            url_ += "orderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (orderDesc !== undefined && orderDesc !== null)
            url_ += "orderDesc=" + encodeURIComponent("" + orderDesc) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageLength !== undefined && pageLength !== null)
            url_ += "pageLength=" + encodeURIComponent("" + pageLength) + "&";
        if (archived !== undefined && archived !== null)
            url_ += "archived=" + encodeURIComponent("" + archived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PageOfAudienceListElement>(options_));
    }

    create(model: AudienceCreateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse> {
        let url_ = "/app/api/marketing/audience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceResponse>(options_));
    }

    get2(id: number, cancelToken?: CancelToken): AxiosPromise<AudienceResponse> {
        let url_ = "/app/api/marketing/audience/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceResponse>(options_));
    }

    update(id: number, model: AudienceUpdateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse> {
        let url_ = "/app/api/marketing/audience/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(model, [
            "$.groups[*].filters.customer.lastCreditCardExpirationDate.from",
            "$.groups[*].filters.customer.lastCreditCardExpirationDate.to",
            "$.groups[*].filters.equipment.installDate.from",
            "$.groups[*].filters.equipment.installDate.to",
            "$.groups[*].filters.equipment.manufacturerWarrantyEnd.from",
            "$.groups[*].filters.equipment.manufacturerWarrantyEnd.to",
            "$.groups[*].filters.equipment.manufacturerWarrantyStart.from",
            "$.groups[*].filters.equipment.manufacturerWarrantyStart.to",
            "$.groups[*].filters.equipment.serviceWarrantyEnd.from",
            "$.groups[*].filters.equipment.serviceWarrantyEnd.to",
            "$.groups[*].filters.equipment.serviceWarrantyStart.from",
            "$.groups[*].filters.equipment.serviceWarrantyStart.to",
            "$.groups[*].filters.membership.creditCardExpirationDate.from",
            "$.groups[*].filters.membership.creditCardExpirationDate.to",
            "$.groups[*].filters.membership.membershipEndDate.from",
            "$.groups[*].filters.membership.membershipEndDate.to",
            "$.groups[*].filters.membership.membershipStartDate.from",
            "$.groups[*].filters.membership.membershipStartDate.to",
            "$.groups[*].filters.membership.nextFollowUpDate.from",
            "$.groups[*].filters.membership.nextFollowUpDate.to",
            "$.groups[*].filters.membership.recurringEventDate.from",
            "$.groups[*].filters.membership.recurringEventDate.to",
            "$.groups[*].filters.recurringServices.recurringEventDate.from",
            "$.groups[*].filters.recurringServices.recurringEventDate.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceResponse>(options_));
    }

    remove(id: number, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/marketing/audience/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    clone(id: number, model: AudienceCreateModel, cancelToken?: CancelToken): AxiosPromise<AudienceResponse> {
        let url_ = "/app/api/marketing/audience/{id}/clone";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceResponse>(options_));
    }

    createGroup(id: number, model: AudienceFilterGroupModel, cancelToken?: CancelToken): AxiosPromise<AudienceFilterGroupModel> {
        let url_ = "/app/api/marketing/audience/{id}/group";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(model, [
            "$.filters.customer.lastCreditCardExpirationDate.from",
            "$.filters.customer.lastCreditCardExpirationDate.to",
            "$.filters.equipment.installDate.from",
            "$.filters.equipment.installDate.to",
            "$.filters.equipment.manufacturerWarrantyEnd.from",
            "$.filters.equipment.manufacturerWarrantyEnd.to",
            "$.filters.equipment.manufacturerWarrantyStart.from",
            "$.filters.equipment.manufacturerWarrantyStart.to",
            "$.filters.equipment.serviceWarrantyEnd.from",
            "$.filters.equipment.serviceWarrantyEnd.to",
            "$.filters.equipment.serviceWarrantyStart.from",
            "$.filters.equipment.serviceWarrantyStart.to",
            "$.filters.membership.creditCardExpirationDate.from",
            "$.filters.membership.creditCardExpirationDate.to",
            "$.filters.membership.membershipEndDate.from",
            "$.filters.membership.membershipEndDate.to",
            "$.filters.membership.membershipStartDate.from",
            "$.filters.membership.membershipStartDate.to",
            "$.filters.membership.nextFollowUpDate.from",
            "$.filters.membership.nextFollowUpDate.to",
            "$.filters.membership.recurringEventDate.from",
            "$.filters.membership.recurringEventDate.to",
            "$.filters.recurringServices.recurringEventDate.from",
            "$.filters.recurringServices.recurringEventDate.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceFilterGroupModel>(options_));
    }

    archive(id: number, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/marketing/audience/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    unarchive(id: number, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/marketing/audience/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    validate(id: number, cancelToken?: CancelToken): AxiosPromise<AudienceValidationResult> {
        let url_ = "/app/api/marketing/audience/{id}/validate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AudienceValidationResult>(options_));
    }

    getAudienceDeliverability(id: number, cancelToken?: CancelToken): AxiosPromise<DeliverabilityBreakdownItem[]> {
        let url_ = "/app/api/marketing/audience/{id}/deliverability";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<DeliverabilityBreakdownItem[]>(options_));
    }
}

export interface PageOfAudienceListElement {
    values: AudienceListElement[];
    isLast: boolean;
    totalCount?: number | undefined;
}

export interface AudienceListElement {
    id: number;
    name: string;
    campaignAssociated: number;
    canBeEdited: boolean;
    campaigns: AudienceCampaign[];
    canBeArchived: boolean;
    totalReach: number;
    emailReach: number;
    mailReach: number;
    phoneReach: number;
    hasAbsoluteDateRangeFilter: boolean;
    createdOn: Date;
    modifiedOn: Date;
    archived: boolean;
    embedded: boolean;
    status: AudienceStatus;
    filtersSetType?: AudienceFiltersSetType | undefined;
    goal: AudienceGoal;
}

export interface AudienceCampaign {
    campaignId: number;
    campaignStatus: MarketingCampaignStatus;
}

export enum MarketingCampaignStatus {
    Draft = 1000,
    Scheduled = 2000,
    Live = 3000,
    Finished = 4000,
    Stopped = 5000,
    Processing = 6000,
}

export enum AudienceStatus {
    Draft = "Draft",
    Active = "Active",
}

export enum AudienceFiltersSetType {
    All = 0,
    RecurringServices = 1,
    UnsoldEstimates = 2,
    NoAudience = 3,
}

export enum AudienceGoal {
    Retain = "Retain",
    Acquire = "Acquire",
}

export interface AudienceResponse {
    id: number;
    totalReach: number;
    emailReach: number;
    mailReach: number;
    phoneReach: number;
    name: string;
    createdOn: Date;
    modifiedOn: Date;
    archived: boolean;
    embedded: boolean;
    status: AudienceStatus;
    goal: AudienceGoal;
    hasAbsoluteDateRangeFilter: boolean;
    groups: AudienceFilterGroupModel[];
    filtersSetType?: AudienceFiltersSetType | undefined;
}

export interface AudienceFilterGroupModel {
    id: number;
    name: string;
    type: ConditionType;
    filters?: EntityFilters | undefined;
    hasAbsoluteDateRangeFilter: boolean;
}

export enum ConditionType {
    Including = "Including",
    Excluding = "Excluding",
}

export interface EntityFilters {
    equipment?: EquipmentFilterDto | undefined;
    invoice?: InvoiceFilterDto | undefined;
    membership?: MembershipFilterDto | undefined;
    estimate?: EstimateFilterDto | undefined;
    customer?: CustomerFilterDto | undefined;
    recurringServices?: RecurringServicesFilterDto | undefined;
    marketingBehavior?: MarketingBehaviorFilterDto | undefined;
    customerCustomFields?: CustomFieldsFilterDto | undefined;
    locationCustomFields?: CustomFieldsFilterDto | undefined;
    jobCustomFields?: CustomFieldsFilterDto | undefined;
}

export interface BaseFilterDto {
}

export interface EquipmentFilterDto extends BaseFilterDto {
    names?: string[] | undefined;
    types?: string[] | undefined;
    tags?: string[] | undefined;
    models?: string[] | undefined;
    zipCodes?: string[] | undefined;
    manufacturers?: string[] | undefined;
    installDate?: UnspecifiedDateRange;
    installDateRelative?: RelativeDateRange;
    manufacturerWarrantyStart?: UnspecifiedDateRange;
    manufacturerWarrantyStartRelative?: RelativeDateRange;
    manufacturerWarrantyEnd?: UnspecifiedDateRange;
    manufacturerWarrantyEndRelative?: RelativeDateRange;
    serviceWarrantyStart?: UnspecifiedDateRange;
    serviceWarrantyStartRelative?: RelativeDateRange;
    serviceWarrantyEnd?: UnspecifiedDateRange;
    serviceWarrantyEndRelative?: RelativeDateRange;
}

export interface UnspecifiedDateRange {
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface RelativeDateRange {
    from?: number | undefined;
    to?: number | undefined;
    direction: TimeDirection;
    comparison: DateComparisonType;
    unit: DateUnit;
}

export enum TimeDirection {
    Past = 0,
    Future = 1,
}

export enum DateComparisonType {
    Less = 0,
    Greater = 1,
    Between = 2,
    Equal = 3,
}

export enum DateUnit {
    Day = 0,
    Week = 1,
    Month = 2,
    Year = 3,
}

export interface InvoiceFilterDto extends BaseFilterDto {
    includeNonJobInvoices?: boolean | undefined;
    total?: DecimalComparision;
    subtotal?: DecimalComparision;
    businessUnits?: ReferenceDto[] | undefined;
    statuses?: InvoiceStatus[] | undefined;
    date?: DateRange;
    dateRelative?: RelativeDateRange;
    jobTypes?: ReferenceDto[] | undefined;
    jobStatuses?: JobStatus[] | undefined;
    jobTags?: string[] | undefined;
    jobScheduled?: DateRange;
    jobScheduledRelative?: RelativeDateRange;
    jobCompleted?: DateRange;
    jobCompletedRelative?: RelativeDateRange;
    services?: string[] | undefined;
    technicians?: ReferenceDto[] | undefined;
    materials?: string[] | undefined;
    equipments?: string[] | undefined;
    taskBusinessUnits?: ReferenceDto[] | undefined;
    zipCodes?: string[] | undefined;
    balance?: DecimalComparision;
    paymentDueDate?: DateRange;
    paymentDueDateRelative?: RelativeDateRange;
}

export interface DecimalComparision {
    type: ComparisonType;
    value: number;
}

export enum ComparisonType {
    Greater = "Greater",
    Less = "Less",
}

export interface ReferenceDto {
    id: number;
    name: string;
}

export enum InvoiceStatus {
    Pending = 0,
    Posted = 1,
    Exported = 2,
}

export interface DateRange {
    from?: Date | undefined;
    to?: Date | undefined;
}

export enum JobStatus {
    Scheduled = 0,
    Dispatched = 1,
    InProgress = 2,
    Hold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface MembershipFilterDto extends BaseFilterDto {
    names?: string[] | undefined;
    recurringServices?: string[] | undefined;
    recurringEventStatus?: RecurringServiceEventStatus[] | undefined;
    status?: MembershipStatus;
    membershipStartDate?: UnspecifiedDateRange;
    membershipStartDateRelative?: RelativeDateRange;
    membershipEndDate?: UnspecifiedDateRange;
    membershipEndDateRelative?: RelativeDateRange;
    recurringEventDate?: UnspecifiedDateRange;
    recurringEventDateRelative?: RelativeDateRange;
    businessUnits?: ReferenceDto[] | undefined;
    remainingFollowUps?: number | undefined;
    nextFollowUpDate?: UnspecifiedDateRange;
    nextFollowUpDateRelative?: RelativeDateRange;
    zipCodes?: string[] | undefined;
    tags?: string[] | undefined;
    creditCardExpirationDate?: UnspecifiedDateRange;
    creditCardExpirationDateRelative?: RelativeDateRange;
}

export enum RecurringServiceEventStatus {
    NotAttempted = 0,
    Unreachable = 1,
    Contacted = 2,
    Won = 3,
    Dismissed = 4,
    JobScheduled = 5,
    JobInProgress = 7,
    JobHold = 8,
    JobCompleted = 9,
    JobCanceled = 10,
}

export enum MembershipStatus {
    Active = 0,
    Suspended = 1,
    Expired = 2,
    Canceled = 3,
    Deleted = 4,
}

export interface EstimateFilterDto extends BaseFilterDto {
    status?: EstimateStatus;
    opportunityStatuses?: OpportunityStatus[] | undefined;
    recommended?: boolean | undefined;
    dateRange?: DateRange;
    dateRangeRelative?: RelativeDateRange;
    total?: DecimalComparision;
    zipCodes?: string[] | undefined;
    jobTypes?: ReferenceDto[] | undefined;
    jobTags?: string[] | undefined;
    businessUnits?: ReferenceDto[] | undefined;
    services?: string[] | undefined;
    technicians?: ReferenceDto[] | undefined;
    materials?: string[] | undefined;
    equipments?: string[] | undefined;
}

export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
}

export enum OpportunityStatus {
    NotAttempted = 0,
    Unreachable = 1,
    Contacted = 2,
    Won = 3,
    Dismissed = 4,
}

export interface CustomerFilterDto extends BaseFilterDto {
    streets?: string[] | undefined;
    units?: string[] | undefined;
    cities?: string[] | undefined;
    states?: string[] | undefined;
    countries?: string[] | undefined;
    locationZipCodes?: string[] | undefined;
    customerZipCodes?: string[] | undefined;
    zones?: string[] | undefined;
    locationTags?: string[] | undefined;
    customerTags?: string[] | undefined;
    jobStatuses?: JobStatus[] | undefined;
    customerType?: CustomerType;
    noJobsSince?: Date | undefined;
    noJobsSinceRelative?: RelativeDateRange;
    jobScheduled?: DateRange;
    jobScheduledRelative?: RelativeDateRange;
    noInboundCallsSince?: Date | undefined;
    noInboundCallsSinceRelative?: RelativeDateRange;
    noOutboundCallsSince?: Date | undefined;
    noOutboundCallsSinceRelative?: RelativeDateRange;
    noEmailsSince?: Date | undefined;
    noEmailsSinceRelative?: RelativeDateRange;
    createdOn?: DateRange;
    createdOnRelative?: RelativeDateRange;
    balance?: DecimalComparision;
    lastCreditCardExpirationDate?: UnspecifiedDateRange;
    lastCreditCardExpirationDateRelative?: RelativeDateRange;
}

export enum CustomerType {
    Residential = 0,
    Commercial = 1,
}

export interface RecurringServicesFilterDto extends BaseFilterDto {
    recurringServices?: string[] | undefined;
    recurringEventStatus?: RecurringServiceEventStatus[] | undefined;
    recurringEventDate?: UnspecifiedDateRange;
    recurringEventDateRelative?: RelativeDateRange;
    technicians?: ReferenceDto[] | undefined;
}

export interface MarketingBehaviorFilterDto extends BaseFilterDto {
    interactionType?: InteractionType;
    campaign?: ReferenceDto;
}

export enum InteractionType {
    Sent = 0,
    NotSent = 1,
    Opened = 2,
    NotOpened = 3,
    Clicked = 4,
    NotClicked = 5,
}

export interface CustomFieldsFilterDto {
    filters: CustomFieldsFilterItem[];
}

export interface CustomFieldsFilterItem {
    filterTypeId: number;
    values: string[];
}

export interface AudienceCreateModel {
    name: string;
    filtersSetType?: AudienceFiltersSetType | undefined;
}

export interface AudienceUpdateModel {
    name: string;
    groups: AudienceFilterGroupModel[];
}

export interface AudienceValidationResult {
    isValid: boolean;
    errors: string[];
}

export interface DeliverabilityBreakdownItem {
    email: string;
    customerId: number;
    name: string;
    deliverabilityStatus: DeliverabilityStatus;
    issues: string[];
    suppressionType?: SuppressionType | undefined;
    unsubscribeGroupTypes: UnsubscribeGroupType[];
}

export enum DeliverabilityStatus {
    Deliverable = 0,
    Undeliverable = 1,
    SemiDeliverable = 2,
    NotSending = 3,
}

export enum SuppressionType {
    Invalid = 0,
    Unsubscribe = 1,
    Bounce = 2,
    SpamReport = 3,
    Block = 4,
    NeverEmail = 5,
}

export enum UnsubscribeGroupType {
    UnsoldEstimates = 1,
    AgingEquipment = 2,
    ExpiringMemberships = 3,
    IdleAccount = 4,
    Other = 5,
    RecurringService = 6,
    Newsletter = 7,
    ThankYou = 8,
    CustomerWelcome = 9,
    MissedCalls = 10,
}
